import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../config/firebase-config';
import { uploadAuctionImage } from './uploadAuctionImage';
import { notifyPermissionDenied } from '../handleCallableError';

export const modifyAuction = async (modifiedAuctionData, context = {}) => {
  const {
    id,
    plate,
    brand,
    model,
    version,
    year,
    kms,
    location,
    finish,
    front,
    existingFrontURL,
    pictures,
    existingPicturesURL,
    apprasing,
    existingApprasingURL,
    observations,
  } = modifiedAuctionData;

  try {
    let frontURL = existingFrontURL;
    let allPicturesURL = existingPicturesURL || [];
    let allApprasingURL = existingApprasingURL || [];

    if (front) {
      frontURL = await uploadAuctionImage(front, {
        imageType: 'front',
        dealershipId: context.dealershipId,
        operatingUnitId: context.operatingUnitId,
        auctionId: id,
      });
    }

    if (pictures && pictures.length) {
      const picturesURLs = await Promise.all(
        pictures.map((image) =>
          uploadAuctionImage(image, {
            imageType: 'pictures',
            dealershipId: context.dealershipId,
            operatingUnitId: context.operatingUnitId,
            auctionId: id,
          })
        )
      );
      allPicturesURL = [...allPicturesURL, ...picturesURLs];
    }

    if (apprasing && apprasing.length) {
      const apprasingURLs = await Promise.all(
        apprasing.map((image) =>
          uploadAuctionImage(image, {
            imageType: 'apprasing',
            dealershipId: context.dealershipId,
            operatingUnitId: context.operatingUnitId,
            auctionId: id,
          })
        )
      );
      allApprasingURL = [...allApprasingURL, ...apprasingURLs];
    }

    const modifyAuctionFn = httpsCallable(functions, 'modifyAuctionV2');
    const result = await modifyAuctionFn({
      id,
      plate,
      brand,
      model,
      version,
      year,
      kms,
      location,
      finish,
      frontURL,
      picturesURL: allPicturesURL,
      apprasingURL: allApprasingURL,
      observations,
      operatingUnitId: context.activeUnitId,
      dealershipId: context.dealershipId,
      requestedApp: 'dealership_web',
    });

    return result.data;
  } catch (error) {
    console.error('Error al modificar la subasta:', error);
    notifyPermissionDenied(error);
    return {
      success: 'no',
      message: 'No se pudo modificar la subasta',
      error: error.message,
    };
  }
};
